import { customerServiceCustomersRoute } from '@atlassian/jira-router-routes-customer-services-customers-routes/src/customerServiceCustomersRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { customerServiceCustomersEntryPoint } from '@atlassian/jira-spa-apps-customer-service-customers/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';

const customerServiceCustomersPageEntryPoint = createPageEntryPoint({
	main: customerServiceCustomersEntryPoint,
});

export const customerServiceCustomersRouteEntry = createEntry(
	customerServiceCustomersRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.customers',
		layout: globalLayout,

		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('berry-6285-customers-l1') ? customerServiceCustomersPageEntryPoint : undefined;
		},

		resources: [...getNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceCustomersRouteEntry.tsx',
				whichExportToUse: 'customerServiceCustomersRouteEntry',
			},

			enabled: true,
		},
	}),
);
